// lighting.js
// Features:
// - Helper function to generate uniform objects for custom shaders
// - Maps configuration objects to Three.js uniforms (Vectors, Colors, Floats)
// - Applies global intensity factors (pointFactor) dynamically

import * as THREE from 'three'

export function getPointLightUniforms(lightControls, pointFactor = 1.0) {
    return {
        // Point Light 1
        uPointLight1Position: {
            value: new THREE.Vector3(
                lightControls.p1PosX,
                lightControls.p1PosY,
                lightControls.p1PosZ
            ),
        },
        uPointLight1Color: {
            value: new THREE.Color(lightControls.p1Color),
        },
        uPointLight1Intensity: {
            value: lightControls.p1Intensity * pointFactor,
        },
        uPointLight1Decay: {
            value: lightControls.p1Decay,
        },
        // Point Light 2
        uPointLight2Position: {
            value: new THREE.Vector3(
                lightControls.p2PosX,
                lightControls.p2PosY,
                lightControls.p2PosZ
            ),
        },
        uPointLight2Color: {
            value: new THREE.Color(lightControls.p2Color),
        },
        uPointLight2Intensity: {
            value: lightControls.p2Intensity * pointFactor,
        },
        uPointLight2Decay: {
            value: lightControls.p2Decay,
        },
        // Point Light 3
        uPointLight3Position: {
            value: new THREE.Vector3(
                lightControls.p3PosX,
                lightControls.p3PosY,
                lightControls.p3PosZ
            ),
        },
        uPointLight3Color: {
            value: new THREE.Color(lightControls.p3Color),
        },
        uPointLight3Intensity: {
            value: lightControls.p3Intensity * pointFactor,
        },
        uPointLight3Decay: {
            value: lightControls.p3Decay,
        },
        // Point light common parameters
        uPointLightSpecularPower: {
            value: lightControls.pSpecularPower,
        },
    }
}
